import React from 'react';
import { observer } from 'mobx-react';
import useData from '20.formLib/DeclarationContainer/AllResolvers/QCScriptsResolver/hooks';
import { QCScriptsResolverProps } from '20.formLib/DeclarationContainer/AllResolvers/QCScriptsResolver/types';
import { useFlattenFields } from '20.formLib/DeclarationContainer/contexts';

const QCScriptsResolver = ({ children }: QCScriptsResolverProps) => {
  const { flattenFields } = useFlattenFields();
  useData(flattenFields);

  return <>{children}</>;
};

export default observer(QCScriptsResolver);
